import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Col, Form, Row, Select, Tabs } from "antd";

import { BackBtn } from "@comm/BackBtn";
import DateCondition from "@comm/search/DateConditionSearch";
import getAllType from "@util/getAllType";
import { setBackInfo } from "@store/modules/back_info";
import TableRelating from "./TableRelating";
import TableRelated from "./TableRelated";
import TableNotRelate from "./TableNotRelate";
// import TagSelect from "@comm/TagSelect/Index";
// import StandardFormRow from "@comm/StandardFormRow/Index";

const FormItem = Form.Item;
const { TabPane } = Tabs;
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refreshFlag: false,
      paymentTypes: [],
      condition: {},
      tabKey: '1',
    };
  }

  componentDidMount() {
    getAllType().then(res => {
      this.setState({
        paymentTypes: res,
      });
    });

    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      this.setState({
        tabKey: backInfo.tabKey,
        condition: backInfo.condition,
      });
    }
  }

  componentWillUnmount() {
    const { tabKey, condition } = this.state;
    const params = {
      path: this.props.location.pathname,
      condition,
      tabKey,
    };
    this.props.dispatch(setBackInfo(params));
  }

  handleChange = params => {
    const { condition } = this.state;
    let obj = {};
    obj = Object.assign(obj, condition);
    obj = Object.assign(obj, params);
    this.setState({
      condition: obj,
    });
  };

  typeChange = e => {
    const { condition } = this.state;
    let obj = {};
    obj = Object.assign(obj, condition);
    obj.type = e;
    this.setState({
      condition: obj,
    });
    return e;
  };

  isConfirmChange = e => {
    const { condition } = this.state;
    let obj = {};
    obj = Object.assign(obj, condition);
    obj.isConfirm = e;
    this.setState({
      condition: obj,
    });
    return e;
  };

  tabsChange = key => {
    this.setState({
      tabKey: key,
    });
  };

  handleRefresh = () => {
    const { refreshFlag } = this.state;
    this.setState({ refreshFlag: !refreshFlag });
  };

  render() {
    const { condition, refreshFlag, paymentTypes, tabKey } = this.state;
    const parentProps = {
      ...this.props,
      paymentTypes,
      refreshFlag,
      condition,
      tabKey,
      handleRefresh: this.handleRefresh,
    };
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Row type="flex" justify="space-between">
          <Col>
            <BackBtn />
          </Col>
          <Col style={{ display: 'flex', justify: 'end' }}>
            <Form layout="inline">
              <FormItem>
                {getFieldDecorator('isConfirm', {
                  getValueFromEvent: this.isConfirmChange,
                  initialValue: condition.isConfirm,
                })(
                  <Select placeholder="匹配情况" style={{ width: '150px' }}>
                    <Select.Option value="">全部</Select.Option>
                    <Select.Option value="0">待匹配</Select.Option>
                  </Select>,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('type', {
                  getValueFromEvent: this.typeChange,
                  initialValue: condition.type,
                })(
                  <Select placeholder="所属类目" style={{ width: '150px' }}>
                    <Select.Option value="">全部</Select.Option>
                    <Select.Option value="111">管理费收入</Select.Option>
                    <Select.Option value="225">退款</Select.Option>
                    <Select.Option value="22e">外部往来款支出</Select.Option>
                    <Select.Option value="129">外部往来款收入</Select.Option>
                  </Select>,
                )}
              </FormItem>
            </Form>
            <DateCondition
              onChange={this.handleChange}
              beginDate={condition.beginDate || ''}
              endDate={condition.endDate || ''}
              condition={condition.condition || ''}
            />
          </Col>
        </Row>
        {/* <Form layout="inline">
          <Card bordered={false} style={{ marginBottom: "16px" }}>
            <StandardFormRow title="匹配情况" block>
              <FormItem>
                {getFieldDecorator("isConfirm", {
                  getValueFromEvent: this.isConfirmChange,
                  initialValue: condition.isConfirm
                })(
                  <TagSelect
                    expandable={false}
                    multiple={false}
                    hideCheckAll={true}
                    value={condition.isConfirm}
                  >
                    <TagSelect.Option value="">全部</TagSelect.Option>
                    <TagSelect.Option value="0">待匹配</TagSelect.Option>
                  </TagSelect>
                )}
              </FormItem>
            </StandardFormRow>
            <StandardFormRow
              title="所属类目"
              block
              style={{ paddingBottom: 11 }}
            >
              <FormItem>
                {getFieldDecorator("type", {
                  getValueFromEvent: this.typeChange,
                  initialValue: condition.type
                })(
                  <TagSelect
                    hideCheckAll={true}
                    multiple={false}
                    value={condition.type}
                  >
                  <TagSelect.Option value="">全部</TagSelect.Option>
                  <TagSelect.Option value="111">管理费收入</TagSelect.Option>
                  <TagSelect.Option value="225">退款</TagSelect.Option>
                  <TagSelect.Option value="22e">
                    外部往来款支出
                  </TagSelect.Option>
                  <TagSelect.Option value="129">
                    外部往来款收入
                  </TagSelect.Option>
                  </TagSelect>
                )}
              </FormItem>
            </StandardFormRow>
          </Card>
        </Form> */}

        <Card>
          <Tabs activeKey={tabKey} onChange={this.tabsChange}>
            <TabPane tab="待关联客户" key="1">
              <TableRelating {...parentProps} />
            </TabPane>
            <TabPane tab="已关联客户" key="2">
              <TableRelated {...parentProps} />
            </TabPane>
            <TabPane tab="不关联客户" key="3">
              <TableNotRelate {...parentProps} />
            </TabPane>
          </Tabs>
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
  backInfo: state.back_info,
}))(Form.create({ wrappedComponentRef: true })(Index));



// WEBPACK FOOTER //
// ./src/components/incubator/income/Index.js